module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "المقدمة"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المقدّمة")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أكثيرةٌ هي الطّموحاتٌ الّتي تبخّرت من بينِ يديكَ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أكثيرون هم مَن أخبروكَ بأنّ الأحلامَ لا تتحقّقُ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أكثيرةٌ هيَ الدّموعُ الّتي سالت لخسارتِك أهدافكَ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل تُؤمنُ بالمعجزاتِ؟! هل جرّبتَ أن تصنعَ واحدةً؟ هل تدركُ بأنّكَ أحدُ المعجزات؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل تؤمنُ بأنّ النّجاح قد يولدُ من رحمِ المعاناة؟ هل تُؤمن بأنّ كتابَ النّجاحِ لا بدَّ وأن يحتويَ على بعضِ سطور الفشل؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل تُؤمنُ بقدرتكَ على كتابةِ قصّةِ نجاحكَ؟ لماذا يجبُ أن تفعلَ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسناً! دعني أخبرُك سراً صغيراً قد أخفاهُ العالمُ عنكَ: أنتَ معجزةٌ، هل سمعتني؟ نعم، أنتَ معجزةٌ في كلِّ تفاصيلِ حياتكَ، في مختلفِ مراحلِ حياتكَ، في تكوينكَ الإعجازيّ، في طريقةِ تفكيركَ. بالنّيابةِ عن المجتمعِ أتقدّمُ لكَ باعتذارٍ عن كلِّ من ثبَّطكَ عن السّعي لأحلامكَ، وأوهمكَ بأنَّ أحلامَ المساءِ لا يمكنُ أن تتحقّقَ مع إشراقةِ شمسِ الصّباحِ. أنا هنا لإكمالِ سطرِ أحلامكَ المهملِ، وإرساءِ سفينةِ طموحاتكَ إلى موانئ الحقيقة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في هذا الكتابِ سأرشدُكَ إلى طريقِ أحلامكَ عن طريق مجموعةٍ من المقالاتِ الإرشاديةِ والقصص الملهمة لأشخاصٍ آمنُوا بقدرتِهم على تحقيق أحلامِهم، واستطاعُوا أن ينيروا دروبَنا بنبراسِ الأمل، ليسطِّروا أروعَ الملاحمِ في سبيلِ تحقيقهم لأحلامِهم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أرجو أن يكونَ الكتابُ بمثابةِ رسالةِ أملٍ، تستدلّون بها على طريقِ أحلامكم، كلّما أظلمَت عليكم دروبُ الحياةِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 75
// module chunks = 0